import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f9298aa&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdditionSite: require('/srv/rir-platform/tourism/src/tourism-front/components/common/AdditionSite/index.vue').default,AdditionPhone: require('/srv/rir-platform/tourism/src/tourism-front/components/common/AdditionPhone/index.vue').default,AdditionMail: require('/srv/rir-platform/tourism/src/tourism-front/components/common/AdditionMail/index.vue').default})
